import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

import { IconLoadersKeys } from './lazyIconRegistry'

/**
 * Maps every program to the icon design calls for when a program has to be identified visually,
 * for example next to the program name of a client's concurrent care session.
 *
 * Icons are held by name rather than by component so that importing the map does not pull every
 * program icon into the importing bundle. Resolve one with `loadIconComponent`.
 */
export const programIcons: Record<ProgramNames, IconLoadersKeys> = {
  [ProgramNames.BlendedCareTherapy]: 'UsersIcon',
  [ProgramNames.DirectAccessIndividualTherapy]: 'UsersIcon',
  [ProgramNames.DIRECT_ACCESS_THERAPY]: 'UsersIcon',
  [ProgramNames.Coaching]: 'TargetIconV2',
  [ProgramNames.SingleSessionCoaching]: 'RadarIcon',
  [ProgramNames.CoachingForParents]: 'CoachingForParentsIcon',
  [ProgramNames.ManagerCoaching]: 'UsersGroupAlt',
  [ProgramNames.MedicationManagement]: 'Pills',
  [ProgramNames.DIRECT_ACCESS_MEDS]: 'Pills',
  [ProgramNames.AlcoholUseDisorderTherapy]: 'SunIcon',
  [ProgramNames.ClinicalLeaveEvaluation]: 'ClinicalLeaveEvalIcon',
  [ProgramNames.SubstanceUseEvaluation]: 'ClinicalLeaveEvalIcon',
  [ProgramNames.TeensTherapy]: 'BackpackIcon',
  [ProgramNames.DirectAccessIndividualAdolescentTherapy]: 'BackpackIcon',
  [ProgramNames.DialecticalBehaviorTherapy]: 'DbtIcon',
  [ProgramNames.DialecticalBehaviorTherapyTeens]: 'DbtIcon',
  [ProgramNames.NeurodiversitySkillsCoaching]: 'BrainIcon',
  [ProgramNames.CaregiverTrainingForNeuro]: 'HandHoldingHeartIcon',
  [ProgramNames.NeuroPsychologicalEvaluations]: 'NeuroPsychEvalIcon',
  [ProgramNames.BehavioralHealthUrgentCare]: 'HospitalIcon',
  [ProgramNames.PediatricVirtualIntensiveOutpatientProgram]: 'HospitalIcon',
  [ProgramNames.PerformanceCoaching]: 'ActivityStarSquareIcon',
  [ProgramNames.DirectAccessCouplesTherapy]: 'CouplesTherapyIcon',
  [ProgramNames.DirectAccessFamilyTherapy]: 'HomeRoofHeart',
  [ProgramNames.DirectAccessIndividualChildTherapy]: 'ChildTherapyIcon',
  [ProgramNames.SELF_CARE_APPS]: 'LeafIcon',
  [ProgramNames.ICASTherapy]: 'GlobeIcon',
  [ProgramNames.IcasIndividualTherapy]: 'GlobeIcon',
}

/**
 * Returns the name of a program's icon, or `undefined` when the program is not one we have an icon
 * for. Pass the result to `loadIconComponent` to get the component.
 */
export const getProgramIconName = (programName: string | undefined): IconLoadersKeys | undefined =>
  programIcons[programName as ProgramNames]
